module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon9.6a4bfc42.png";